import { TransferSearchResult } from './useTransfers/types'
import useAxios from './useAxios'
import qs from 'qs'
import { tr } from 'date-fns/locale'

export type Disclaimer = {
  title: string
  description: string
}

export interface DisclaimerShowResponse {
  disclaimers: Disclaimer[]
}

const useDisclaimers = () => {
  const instance = useAxios()

  const show = async (transfer: TransferSearchResult) => {
    const { booking_id, session_id, provider } = transfer
    const query = qs.stringify({ booking_id, session_id, provider }, { addQueryPrefix: true })

    return await instance.get<DisclaimerShowResponse>(`ac/v1/disclaimers${query}`)
  }

  return {
    show,
  }
}

export default useDisclaimers
